import styled from 'styled-components';

export const FloatingPanelButton = styled.button`
  border: none;
  flex: 1;
  padding: 8px 12px;

  --background-color: var(--white);
  background-color: var(--background-color);

  :active {
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, var(--pressed-alpha)) 0%,
        rgba(0, 0, 0, var(--pressed-alpha)) 100%
      ),
      var(--background-color);
  }
`;

export const ButtonContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const BottomButtonText = styled.span`
  color: var(--black);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
`;
